import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { EmploymentDetail } from '../../Models/Models/Customer/EmploymentDetail';

declare var IS_RUNNING_IN_APP_POOL;

export class EmploymentDetailClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(customerId: number): Promise<EmploymentDetail, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/EmploymentDetail/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { customerId: customerId }

    return AjaxWrapper.get<EmploymentDetail, any>(url, data);
  }
  public put(customerId: number, employmentDetail: EmploymentDetail): Promise<EmploymentDetail, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/EmploymentDetail/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { customerId: customerId, employmentDetail: employmentDetail }

    return AjaxWrapper.put<EmploymentDetail, any>(url, data);
  }
}

